import React from 'react';
import {
  ApButtonGroup,
  ApButtonSecondary,
  ApButtonDanger,
} from '@alixpartners/ui-components';
import {
  StyledModal,
  TextContent,
  ProvidersList,
  ProviderItem,
} from './SaveIndustryBlendConfirmation.styles';

interface IProps {
  isOpen: boolean;
  onConfirm: () => void;
  onClose(): void;
  providers: any[];
}

export const SaveIndustryBlendConfirmation: React.FC<IProps> = ({
  isOpen,
  onConfirm,
  onClose,
  providers,
}) => {
  return (
    <StyledModal
      isOpen={isOpen}
      header=""
      isDismissible
      hasClosed={onClose}
      footer={() => {
        return (
          <ApButtonGroup justifyContent="flex-end">
            <ApButtonSecondary onClick={onClose}>Cancel</ApButtonSecondary>
            <ApButtonDanger onClick={onConfirm}>Procced Save</ApButtonDanger>
          </ApButtonGroup>
        );
      }}
    >
      <TextContent>
        The benchmark below are unavailable for the selected year. They will be
        substituted by the years shown for this blend.
        <br />
        <br />
        <ProvidersList>
          {providers.map((provider) => (
            <ProviderItem
              key={`${provider.l1Category}-${provider.provider}-${provider.year}`}
            >
              {provider.l1Category} ({provider.provider}) - {provider.year}
            </ProviderItem>
          ))}
        </ProvidersList>
      </TextContent>
    </StyledModal>
  );
};
